import { MatrixClient } from 'matrix-js-sdk/src';

import logger from 'utils/logging/faro';
import { commonStateKeys, CustomMeedioMatrixEvents } from 'utils/matrixUtils';
import { ScheduledDate } from 'utils/types';

interface SendScheduleStateEventProps {
  client: MatrixClient;
  roomId: string;
  startsAt: ScheduledDate;
  endsAt: ScheduledDate;
  isStarted?: boolean;
}

export const sendScheduleStateEvent = ({
  client,
  roomId,
  startsAt,
  endsAt,
  isStarted = false,
}: SendScheduleStateEventProps) =>
  client
    .sendStateEvent(
      roomId,
      CustomMeedioMatrixEvents.IS_SCHEDULED_CALL_STATE_EVENT,
      { startsAt, endsAt, isStarted },
      commonStateKeys.default
    )
    .catch((error) => {
      logger.error('Error sending schedule state event:', error);
      throw error;
    });
